import useNewUserParam from "@/components/Auth/shared/hooks/useNewUserParam";
import useAuthStore from "@/components/Auth/shared/store.auth";
import useAppQueryParam from "@/hooks/useAppQueryParam";
import useDeviceType from "@/hooks/useDeviceType";
import { fetchDownloadLinks, TDownloadLinks } from "@/utils/getDownloadLinks";
import { useQuery } from "@tanstack/react-query";
import { useCallback, useEffect, useState } from "react";
import AppModal from "../shared/AppModal/AppModal";
import DownloadStatusCard from "./components/DownloadStatusCard";

const ShowAutoDownload = () => {
  const [showModal, setShowModal] = useState(true);
  const { authOutcome, clearAuthOutcome } = useAuthStore();
  const isNewUser = authOutcome === "new-user";
  const { removeQueryParam } = useAppQueryParam();

  const { isMobileOrTablet } = useDeviceType();
  useNewUserParam();

  const { data: downloadData } = useQuery<TDownloadLinks>({
    queryKey: ["download-links"],
    queryFn: fetchDownloadLinks,
  });

  const getDownloadLink = useCallback(() => {
    const userAgent = navigator.userAgent.toLowerCase();

    let downloadLink: string | undefined = "";

    if (/win/i.test(userAgent)) {
      downloadLink = downloadData?.windows;
    } else if (/mac/i.test(userAgent)) {
      const canvas: HTMLCanvasElement = document.createElement("canvas");
      const gl: WebGLRenderingContext | null =
        (canvas.getContext("webgl") as WebGLRenderingContext) ||
        (canvas.getContext("experimental-webgl") as WebGLRenderingContext);

      if (gl) {
        const info: WEBGL_debug_renderer_info | null = gl.getExtension(
          "WEBGL_debug_renderer_info",
        );
        if (info) {
          const renderer: string | null = gl.getParameter(
            info.UNMASKED_RENDERER_WEBGL,
          );
          const vendor: string | null = gl.getParameter(
            info.UNMASKED_VENDOR_WEBGL,
          );

          if (renderer && vendor) {
            if (renderer.toLowerCase().includes("apple")) {
              downloadLink = downloadData?.apple_m1;
            } else if (renderer.toLowerCase().includes("intel")) {
              downloadLink = downloadData?.apple_intel;
            } else {
              downloadLink = "";
            }
          }
        }
      }
    }

    return downloadLink;
  }, [downloadData?.version]);

  const downloadFile = async () => {
    const downloadLink = getDownloadLink();

    if (!downloadLink) {
      console.warn("Download link not found");
      return;
    }

    window.location.href = downloadLink;
    // @ts-ignore
    window.gtag("event", "app_download");
    // @ts-ignore
    window.fbq("track", "lead");
  };

  const handleModalClose = () => {
    setShowModal(false);
    removeQueryParam("newUser");
  };

  useEffect(() => {
    if (!downloadData || !isNewUser) return;

    if (!isMobileOrTablet) {
      downloadFile();
    }
  }, [downloadData, isNewUser, isMobileOrTablet]);

  useEffect(() => () => clearAuthOutcome(), []);

  if (isMobileOrTablet || !isNewUser) return null;

  return (
    <div>
      <AppModal
        modalState={showModal}
        handleCloseModal={handleModalClose}
        className="max-w-[442px] rounded-2xl bg-white p-0"
      >
        <DownloadStatusCard handleDownload={downloadFile} />
      </AppModal>
    </div>
  );
};

export default ShowAutoDownload;
